import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { getFirstError } from '../../forms/validation';
import { InputErrors } from '../../forms/errors';
import { v4 as uuidv4 } from 'uuid';

type InputType =
  'color' | 'date' | 'datetime-local' | 'email' | 'file' | 'month' | 'number'
  | 'password' | 'search' | 'tel' | 'text' | 'time' | 'url' | 'week';

@Component({
  selector: 'app-text-input',
  templateUrl: './text-input.component.html',
  styleUrls: ['./text-input.component.scss'],
  standalone: false
})
export class TextInputComponent implements OnInit {
  @Input()
  public bold = false;

  @Input()
  public name: string;

  @Input()
  public labelName = 'Password';

  @Input()
  public placeholder = '';

  /** The control to present. Use this OR value, not both. */
  @Input()
  public control = new FormControl<string>('');

  /** The value to present. Use this OR control, not both. */
  @Input()
  public set value(newValue: string) {
    this._value = newValue;
    this.control?.setValue(newValue);
  }
  public get value(): string {
    return this._value;
  }

  @Input()
  public errors: InputErrors = {};

  @Input()
  public type: InputType = 'text';

  @Input()
  public readonly = false;

  /**
   * Whether to show the Copy link button, for copying the value of this input.
   */
  @Input()
  public copy = false;

  /** The text to show on the Copy button */
  @Input()
  public copyText = 'Copy';

  @Input()
  public autocomplete = 'on';

  @HostBinding('class.has-errors')
  public get hasErrorsClass() { return this.showError; }

  public inputId = `input-${uuidv4()}`;
  public masked = false;
  private _value: string;

  public ngOnInit() {
    if (this.isPassword) {
      this.masked = true;
    }
  }

  public get formControlType(): InputType {
    if (this.isPassword) {
      return this.masked ? 'password' : 'text';
    } else {
      return this.type;
    }
  }

  public get isPassword(): boolean {
    return this.type === 'password';
  }

  public get showError(): boolean {
    return this.control.touched && !!this.control.errors && !!this.errorPresentation;
  }

  public get errorPresentation(): string | null {
    const firstError = getFirstError(this.control);
    if (!firstError) {
      return null;
    }

    const errorMessage = this.errors[firstError];
    if (typeof errorMessage === 'function') {
      return errorMessage(this.control.getError(firstError));
    } else {
      return errorMessage ?? null;
    }
  }

  public toggleMasking(): void {
    this.masked = !this.masked;
  }
}
